import React from "react";
import VStack from "../../../ui_atoms/VStack";
import { newMissionState } from "../../../atoms/core";
import CreateMissionJobTitle from "../../../screens/create-mission/CreateMissionJobTitle";
import { FIND_ACTIVITY_TYPE } from "../../../graphql/core";
import { MockedProvider } from "@apollo/client/testing/react";
import { MockedAuthManager } from "../../../contexts/AuthManager";
import { Gender, ProfileType } from "../../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import {
    buildActivityType,
    buildClient,
    buildClientProfile,
    buildUser,
    buildWorkerProfile,
} from "../../factories";
import CreateMissionManager from "../../../contexts/CreateMissionManager";
import { MockedProfileSwitcherManager } from "../../../contexts/ProfileSwitcherManager";
import { AtomsHydrator } from "../../../atoms/atoms-hydrator";

function StoryComponent() {
    const mocks = [
        {
            request: {
                query: FIND_ACTIVITY_TYPE,
                variables: () => true,
            },
            result: () => ({
                data: {
                    findActivityType: {
                        pageInfo: {
                            totalElements: 1,
                            hasNextPage: false,
                            hasPreviousPage: false,
                            startCursor: "fake-start-cursor",
                            endCursor: "fake-end-cursor",
                        },
                        elements: [
                            buildActivityType(),
                            {
                                id: "activity-01",
                                title: "The only one activity",
                            },
                        ],
                    },
                },
            }),
        },
    ];

    return (
        <AtomsHydrator
            atomValues={[
                [
                    newMissionState,
                    {
                        id: "fake-id",
                        currentContract: { contractEffectiveAsset: { id: "007" } },
                        workerInfo: {
                            gender: Gender.Female,
                        },
                    },
                ],
            ]}
        >
            <MockedProvider mocks={mocks}>
                <MockedAuthManager
                    user={buildUser({
                        id: "1",
                        gender: Gender.Female,
                        clientProfiles: [
                            buildClientProfile({
                                id: "cp-1",
                                client: buildClient({ id: "c-2", name: "Client name" }),
                            }),
                        ],
                        workerProfile: buildWorkerProfile({ id: "wp-1" }),
                    })}
                    setAppExpoPushToken={() => {}}
                >
                    <MockedProfileSwitcherManager profileType={ProfileType.Client}>
                        <VStack
                            gap={1}
                            style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}
                        >
                            <CreateMissionManager>
                                <CreateMissionJobTitle />
                            </CreateMissionManager>
                        </VStack>
                    </MockedProfileSwitcherManager>
                </MockedAuthManager>
            </MockedProvider>
        </AtomsHydrator>
    );
}

const meta = {
    title: "CreateMission/Job title",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
